import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Icon from '@/components/Base/Icon';

import {
  FilterButton,
  FilterButtonText,
  IconFiltersWrapper,
} from './FiltersMoreButton.styles';

function FiltersMoreButton({
  isActive = false,
  handleClick,
  filterButtonAttrs = {},
  ...rest
}) {
  const { formatMessage } = useIntl();

  return (
    <FilterButton
      onClick={(e) => handleClick(e)}
      {...filterButtonAttrs}
      {...rest}
    >
      <IconFiltersWrapper $isActive={isActive}>
        <Icon name="filters" />
      </IconFiltersWrapper>

      <FilterButtonText>{formatMessage({ id: 'filters' })}</FilterButtonText>
    </FilterButton>
  );
}

FiltersMoreButton.propTypes = {
  isActive: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
  filterButtonAttrs: PropTypes.objectOf(PropTypes.any),
};

export default memo(FiltersMoreButton);
